<template>
    <div class="loader-component">
        <b-spinner variant="primary" label="Spinning" />
        <span class="message">{{$t('loader.message')}}</span>
    </div>
</template>

<script lang="ts">

import Component from "vue-class-component";
import {BSpinner} from "bootstrap-vue";
import Vue from "vue";

@Component({
    components: { BSpinner }
})
class Loader extends Vue {

}
export default Loader;
</script>

<style scoped lang="scss">
    .loader-component {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .message {
            display: block;
            margin-left: 0.5em;
        }
    }
</style>